import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Sidebar from './Components/sidebar/Sidebar';
import Dashboard from './Components/dashboard/Dashboard';
import Course from './Components/course/Course';
import StudentAdd from './Components/student/StudentAdd';
import Student from './Components/student/Student';
import Login from './Components/Login/Login';
import DateFilter from './Components/student/student1';
import Mentor from './Components/mentor/Mentor';
import Invoice from './Components/invoice/Invoive';
import InvoiceNew from './Components/invoice/invoice1';

import Enquiry from './Components/enquiry/Enquiry';
import Internship from './Components/internship/Internship';
import Jobassist from './Components/Jobassit/Jobassist';

import Career from './Components/career/Career';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState(localStorage.getItem('role'));
  const timeoutRef = useRef(null);

  const logout = useCallback(() => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('role');
    setIsAuthenticated(false);
    window.location.href = '/';
  }, []);

  const resetTimer = useCallback(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      logout();
    }, 15 * 60 * 1000);
  }, [logout]);

  useEffect(() => {
    const isAuth = localStorage.getItem('isAuthenticated') === 'true';
    const userRole = localStorage.getItem('role');
    setIsAuthenticated(isAuth);
    setRole(userRole);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      window.addEventListener('mousemove', resetTimer);
      window.addEventListener('keypress', resetTimer);
      window.addEventListener('scroll', resetTimer);
      window.addEventListener('click', resetTimer);
      resetTimer();
    }
    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress', resetTimer);
      window.removeEventListener('scroll', resetTimer);
      window.removeEventListener('click', resetTimer);
    };
  }, [isAuthenticated, resetTimer]);

  return (

    <Router>
      {!isAuthenticated ? (
        <Routes>
          <Route path="/" element={
            <Login onLogin={() => {
              setIsAuthenticated(true);
              setRole(localStorage.getItem('role'));
            }} />
          } />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      ) : (
        <div style={{ display: 'flex' }}>
          <Sidebar onLogout={logout} role={role} />
          <div style={{ marginLeft: '200px', padding: '20px', width: '100%' }}>
            <Routes>
              <Route path="/dashboard" element={<Dashboard onLogout={logout} />} />
              <Route path="/enquiry" element={<Enquiry onLogout={logout} role={role} />} />
              <Route path="/career" element={<Career onLogout={logout}  role={role}/>} />
              {role === 'admin' && (
                <>
                  <Route path="/course" element={<Course onLogout={logout} />} />
                  <Route path="/student" element={<Student onLogout={logout} />} />
                  <Route path="/studentadd" element={<StudentAdd onLogout={logout} />} />
                  <Route path="/date" element={<DateFilter />} />
                  <Route path="/mentor" element={<Mentor onLogout={logout} />} />
                  <Route path="/invoice" element={<Invoice onLogout={logout} />} />
                  <Route path="/invoice1" element={<InvoiceNew onLogout={logout} />} />
                  <Route path="/intern" element={<Internship onLogout={logout} />} />
                  <Route path="/jobassits" element={<Jobassist onLogout={logout} />} />

                  {/* <Route path="/student1" element={<Student1 />} /> */}
                </>
              )}
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </div>
        </div>
      )}
    </Router>
  );


}

export default App;
